import React from 'react';
import { Link } from 'react-router-dom';

// Shown in place of the "Logging in..." state when a magic-link token is
// rejected. getAuth sets `error.linkInvalid` for the API's expired/used-link
// rejection and `error.apiMessage` for any other 4xx (e.g. a disabled
// account); transport and 5xx failures get generic copy so we do not blame
// the link.
const copyFor = error => {
  if (error?.linkInvalid) {
    return {
      title: 'This login link is no longer valid',
      body: 'Login links expire after one hour and can only be used once. Request a new one to sign in.'
    };
  }

  return {
    title: "We couldn't sign you in",
    body: error?.apiMessage
      || 'Something went wrong while checking your login link. Please try again or request a new one.'
  };
};

export default function AuthLinkError({ error, to = '/', label = 'Request a new link' }) {
  const { title, body } = copyFor(error);

  return (
    <div className="container has-text-centered" role="alert">
      <div className="title mt-4">{title}</div>
      <div className="subtitle mb-4">{body}</div>

      <div className="buttons is-centered">
        <Link to={to} className="button is-link">
          <span>{label}</span>
        </Link>
      </div>
    </div>
  );
}
